/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from "vue";

import VueSimpleAlert from "vue-simple-alert";

Vue.use(VueSimpleAlert);

require('./bootstrap');

window.Vue = require('vue');
Vue.config.productionTip = false

Vue.filter('phone', function (value) {
    if(!value) return '';
    if(value.length < 11) {
        for(var i = 0; i < value.length - 11; i++) {
            value = '0' + value;
        }
    }
    let x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    return !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
});
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('BuyBtn', require('./components/partial/BuyBtn').default);
Vue.component('BuyDirectGroup', require('./components/partial/BuyDirectGroup').default);
Vue.component('CartHead', require('./components/partial/CartHead').default);
Vue.component('Cart', require('./components/pages/Cart').default);
Vue.component('checkoutstepa', require('./components/pages/CheckoutStep1').default);
Vue.component('ResetCart', require('./components/partial/ResetCart').default);
Vue.component('FindComputer', require('./components/partial/FindComputer').default);
Vue.component('TunerSearchBlock', require('./components/partial/TunerSearchBlock').default);
Vue.component('TuningSearchBtn', require('./components/partial/TuningSearchBtn').default);
Vue.component('CombineModuleNumbersBlock', require('./components/partial/CombineModuleNumbersBlock').default);

Vue.component('OurReviews', require('./components/partial/product/OurReviews').default);
Vue.component('CountDownWithoutPickup', require('./components/partial/product/CountDownWithoutPickup').default);
Vue.component('CountDownWithPickup', require('./components/partial/product/CountDownWithPickup').default);
Vue.component('CreateCookie', require('./components/partial/product/CreateCookie').default);

Vue.component('VehicleInformationForm', require('./components/pages/VehicleInformationForm').default);
Vue.component('DieselInformationForm', require('./components/pages/DieselInformationForm').default);
Vue.component('PayWithPayPal', require('./components/partial/PayWithPayPal').default);

Vue.component('ProductAttributesDropdowns', require('./components/partial/ProductAttributesDropdowns').default);
Vue.component('ProductOptionsDropdowns', require('./components/partial/ProductOptionsDropdowns').default);



import ElementUI from 'element-ui'
import locale from "element-ui/lib/locale/lang/en";
Vue.use(ElementUI, { locale })
// SCSS
import './admin/styles/main.scss'




const app = new Vue({
    el: '#main'
});
